export default __webpack_public_path__ + "static/media/image.f53b7d57.jfif";